export const DISTRIBUTOR = [
  { key: "1", label: "distributor 1" },
  { key: "2", label: "distributor 2" },
  { key: "3", label: "distributor 3" },
];
export const STATUS = ["Lead", "Demo", "Sale", "NoSale"]; //final

export const PRODUCTGROUP = [
  { key: "1635543000001492005", label: "Freestyle® OA Knee Brace" },
  {
    key: "1635543000001492643",
    label: "T Scope® Premier Post - Op Knee Brace",
  },
  { key: "1635543000001492876", label: "Atlas" },
]; //sample
export const DOCTOR = [
  { Full_Name: "Amin Rajani", id: "343275000002850071" },
  { Full_Name: "Shabbir Suterwala", id: "343275000001145335" },
  { Full_Name: "Pradeep Moonot", id: "343275000001145326" },
  { Full_Name: "Mihir Patel", id: "343275000001145325" },
  { Full_Name: "Harshad Sonavane", id: "343275000009375003" },
]; //sample

export const PRODUCTCODE = [
  { code: "Freestyle OA Med RT M", id: "1635543000001503688" },
  { code: "SEcon Hinged Knee AM OB WA M", id: "343275000001145335" },
 
]; //sample
export const PRODUCTNAME = [
  {  id: 1,name: "Freestyle OA Med RT M", code: "1635543000001503688" },
  { id: 2, name: "SEcon Hinged Knee AM OB WA M", code: "343275000001145335" },
 
]; //sample

export const USERGROUP = [
  { name: "Internal User", id: "1" },
  { name: "Distributor", id: "2" },
  { name: "Distributor admin", id: "3" },
  { name: "Internal manager", id: "4" },
 
]; //sample
export const PRODUCTDATA = {
  "Genesis Full Shell Walker 4 Strp1": [
    { name: "Freestyle OA Med RT L", price: "50.00" },
    { name: "Walker Assist RT", price: "45.00" },
  ],
  "Ligament Brace": [
    { name: "ARC 2.0 Sling", price: "30.00" },
    { name: "Deluxe Knee Brace", price: "35.00" },
  ],
};

export const COMPANIES = [
  { value: "Alpha Dev Healthcare", label: "Alpha Dev Healthcare" },
  { value: "Alpha Mediways", label: "Alpha Mediways" },
  { value: "Arthromed", label: "Arthromed" },
  { value: "Aroga health care", label: "Aroga health care" },
  { value: "B&J Healthcare Pvt Ltd", label: "B&J Healthcare Pvt Ltd" },
  { value: "Bionics Ortho Aids Services", label: "Bionics Ortho Aids Services" },
  { value: "Bluten pharmaceuticals", label: "Bluten pharmaceuticals" },
  { value: "Cherry Life", label: "Cherry Life" },
  { value: "J. J Enterprises", label: "J. J Enterprises" },
  { value: "Lifecare Enterprises", label: "Lifecare Enterprises" },
  { value: "Magneq Health care", label: "Magneq Health care" },
  { value: "MAS Healthcare", label: "MAS Healthcare" },
  { value: "Meddey Technologies", label: "Meddey Technologies" },
  { value: "Medicant", label: "Medicant" },
  { value: "Medyptus Solutions", label: "Medyptus Solutions" },
  // { value: "Midlife health care", label: "Midlife health care" },
  { value: "Medlife Healthcare", label: "Medlife Healthcare" },
  { value: "Nams California Technologies", label: "Nams California Technologies" },
  { value: "New Friends Healthcare", label: "New Friends Healthcare" },
  { value: "Nulife Healthcare", label: "Nulife Healthcare" },
  { value: "Om Sai Healthcare", label: "Om Sai Healthcare" },
  // { value: "PORC", label: "PORC" },
  { value: "Prosthetic & Orthotic Rehabilitation Clinic", label: "Prosthetic & Orthotic Rehabilitation Clinic" },
  { value: "Prabhu Surgicals Pvt Ltd", label: "Prabhu Surgicals Pvt Ltd" },
  { value: "Spectramed Surgical Solutions", label: "Spectramed Surgical Solutions" },
  { value: "Sportzmed Agencies", label: "Sportzmed Agencies" },
  { value: "Swara Medicare", label: "Swara Medicare" },
  { value: "Uma Suresh Agency", label: "Uma Suresh Agency" },
  { value: "Viraat medical devices", label: "Viraat medical devices" },
  { value: "Green Apple Healthcare Pvt Ltd", label: "Green Apple Healthcare Pvt Ltd" },
  { value: "Perseus Tech Pvt Ltd", label: "Perseus Tech Pvt Ltd" },
  { value: "Nikhil Surgical", label: "Nikhil Surgical" },
  { value: "Divya Healthcare", label: "Divya Healthcare" },
  { value: "I Touch Surgical", label: "I Touch Surgical" },
  { value: "Samarth Surgical", label: "Samarth Surgical" },
  { value: "SPANDAN ENTERPRISES", label: "SPANDAN ENTERPRISES" },
  { value: "Aeon Medical Devices Pvt Ltd", label: "Aeon Medical Devices Pvt Ltd" },
  { value: "Le Cygne Ventures LLP", label: "Le Cygne Ventures LLP" },
  { value: "Israna Surgical", label: "Israna Surgical" },
  { value: "Chitrarath", label: "Chitrarath" },
  { value: "Sanshok Enterprises", label: "Sanshok Enterprises" },
  { value: "Health Park", label: "Health Park" },
  { value: "Garuda Healthcare", label: "Garuda Healthcare" },
  { value: "Pack Deal", label: "Pack Deal" },
  { value: "Ortho Speciality Pharmacy", label: "Ortho Speciality Pharmacy" },
];

export const CompaniesWithValue = [
  { value: "1635543000000095845", label: "Medicant" },
  { value: "1635543000007282849", label: "I Touch Surgical" },
  { value: "1635543000002139457", label: "Arise Enterprise" },
  { value: "1635543000000090917", label: "Alpha Dev Healthcare" },
  { value: "1635543000000090939", label: "Alpha Mediways" },
  { value: "1635543000000091159", label: "Aroga health care" },
  { value: "1635543000000091181", label: "Arthromed" },
  { value: "1635543000004358103", label: "B&J Healthcare Pvt Ltd" },
  { value: "1635543000000091621", label: "Bluten pharmaceuticals" },
  { value: "1635543000000095911", label: "Medyptus Solutions" },
  { value: "1635543000000098903", label: "Nams California Technologies" },
  { value: "1635543000000100091", label: "Spectramed Surgical Solutions" },
  { value: "1635543000000100135", label: "Sportzmed Agencies" },
  { value: "1635543000000100509", label: "Swara Medicare" },
  { value: "1635543000000100971", label: "Viraat medical devices" },
  { value: "1635543000000091533", label: "Bionics Ortho Aids Services" },
  { value: "1635543000000095251", label: "J. J Enterprises" },
  { value: "1635543000000095735", label: "Magneq Health care" },
  { value: "1635543000000095801", label: "MAS Healthcare" },
  { value: "1635543000000095823", label: "Meddey Technologies" },
  { value: "1635543000000100795", label: "Uma Suresh Agency" },
  { value: "1635543000000099057", label: "Nulife Healthcare" },
  { value: "1635543000000098991", label: "Nikhil Surgical" },
  { value: "1635543000000099079", label: "Om Sai Healthcare" },
  // { value: "1635543000001579041", label: "PORC" },
  { value: "1635543000000099475", label: "Prosthetic & Orthotic Rehabilitation Clinic" },
  // { value: "1635543000001579063", label: "Midlife health care" },
  { value: "1635543000000095889", label: "Medlife Healthcare" },
  { value: "1635543000001579085", label: "New Friends Healthcare" },
  { value: "1635543000000099321", label: "Prabhu Surgicals Pvt Ltd" },
  { value: "1635543000000091775", label: "Cherry Life" },
  { value: "1635543000000095691", label: "Lifecare Enterprises" },
  { value: "1635543000000094987", label: "Green Apple Healthcare Pvt Ltd" },
  { value: "1635543000000094767", label: "ENBE TECHSERV" },
  { value: "1635543000007577241", label: "Divya Healthcare" },
  { value: "1635543000007365932", label: "Perseus Tech Pvt Ltd" },
  { value: "1635543000000099695", label: "Samarth Surgical" },
  { value: "1635543000001769441", label: "SPANDAN ENTERPRISES" },
  { value: "1635543000022954386", label: "Aeon Medical Devices Pvt Ltd" },
  { value: "1635543000013626068", label: "Le Cygne Ventures LLP" },
  { value: "1635543000024495253", label: "Israna Surgical" },
  { value: "1635543000035380249", label: "Chitrarath" },
  { value: "1635543000036431574", label: "Sanshok Enterprises" },
  { value: "1635543000036775037", label: "Health Park" },
  { value: "1635543000039672277", label: "Garuda Healthcare" },
  { value: "1635543000040182163", label: "Pack Deal" },
  { value: "1635543000035430408", label: "Ortho Speciality Pharmacy" },
]


export const DOCTORS = [
  { value: "Vijay Mohan", label: "Vijay Mohan" },
  { value: "Renjith KR", label: "Renjith KR" },
  { value: "Jikku Haniball", label: "Jikku Haniball" },
  { value: "Ajayakumar T", label: "Ajayakumar T" },
  { value: "Rajesh Pmr", label: "Rajesh Pmr" },
  { value: "Sunil Physio", label: "Sunil Physio" },
  { value: "Kavitha Panchal", label: "Kavitha Panchal" },
  { value: "Sudheesh Karunakaran", label: "Sudheesh Karunakaran" },
  { value: "Sujith Jose", label: "Sujith Jose" },
  { value: "Rajesh S Simon", label: "Rajesh S Simon" },
  { value: "Vinay Jason", label: "Vinay Jason" },
  { value: "Manjunath Dr", label: "Manjunath Dr" },
  { value: "Raj Mohan", label: "Raj Mohan" },
  { value: "Subramaniam P", label: "Subramaniam P" },
  { value: "Vijayan Kurup", label: "Vijayan Kurup" },
  { value: "Mohammed Riyadh", label: "Mohammed Riyadh" },
  { value: "Varun Amrita", label: "Varun Amrita" },
  { value: "Rajesh Amrita", label: "Rajesh Amrita" },
  { value: "Seena Amrita", label: "Seena Amrita" },
  { value: "Ravisankaran Amrita", label: "Ravisankaran Amrita" },
  { value: "Murugan Babu", label: "Murugan Babu" },
  { value: "Tom Jose", label: "Tom Jose" },
  { value: "John T", label: "John T" },
  { value: "Azad Dr", label: "Azad Dr" },
  { value: "Nishanth N", label: "Nishanth N" },
  { value: "Jacob V", label: "Jacob V" },
  { value: "George Vv", label: "George Vv" },
  { value: "Manu Pv", label: "Manu Pv" },
  { value: "Nijith G", label: "Nijith G" },
  { value: "Thady Mohan", label: "Thady Mohan" },
  { value: "Vipin Sh", label: "Vipin Sh" },
  { value: "Arun Prakash", label: "Arun Prakash" }
];

export const DOCTORS1 = [
  { value: "1", label: "Vijay Mohan" },
  { value: "2", label: "Renjith KR" },
  { value: "3", label: "Jikku Haniball" },
  { value: "4", label: "Ajayakumar T" },
  { value: "5", label: "Rajesh Pmr" },
  { value: "6", label: "Sunil Physio" },
  { value: "7", label: "Kavitha Panchal" },
  { value: "8", label: "Sudheesh Karunakaran" },
  { value: "9", label: "Sujith Jose" },
  { value: "10", label: "Rajesh S Simon" },
  { value: "11", label: "Vinay Jason" },
  { value: "12", label: "Manjunath Dr" },
  { value: "13", label: "Raj Mohan" },
  { value: "14", label: "Subramaniam P" },
  { value: "15", label: "Vijayan Kurup" },
  { value: "16", label: "Mohammed Riyadh" },
  { value: "17", label: "Varun Amrita" },
  { value: "18", label: "Rajesh Amrita" },
  { value: "19", label: "Seena Amrita" },
  { value: "20", label: "Ravisankaran Amrita" },
  { value: "21", label: "Murugan Babu" },
  { value: "22", label: "Tom Jose" },
  { value: "23", label: "John T" },
  { value: "24", label: "Azad Dr" },
  { value: "25", label: "Nishanth N" },
  { value: "26", label: "Jacob V" },
  { value: "27", label: "George Vv" },
  { value: "28", label: "Manu Pv" },
  { value: "29", label: "Nijith G" },
  { value: "30", label: "Thady Mohan" },
  { value: "31", label: "Vipin Sh" },
  { value: "32", label: "Arun Prakash" }
];


export const COMPANIES1 = [
            "Medicant",
            "Alpha Dev Healthcare",
            "Alpha Mediways",
            "Aroga health care",
            "Arthromed",
            "B&J Healthcare Pvt Ltd",
            "Bluten pharmaceuticals",
            "Medyptus Solutions",
            "Nams California Technologies",
            "Spectramed Surgical Solutions",
            "Sportzmed Agencies",
            "Swara Medicare",
            "Viraat medical devices",
            "Bionics Ortho Aids Services",
            "J. J Enterprises",
            "Magneq Health care",
            "MAS Healthcare",
            "Meddey Technologies",
            "Uma Suresh Agency",
            "Nulife Healthcare",
            "Om Sai Healthcare",
            "PORC",
            // "Midlife health care",
            "Medlife Healthcare",
            "New Friends Healthcare",
            "Prabhu Surgicals Pvt Ltd",
            "Cherry Life",
            "Lifecare Enterprises",
            "Chitrarath",
            "Sanshok Enterprises",
            "Health Park",
            "Garuda Healthcare",
            "Pack Deal",
            "Ortho Speciality Pharmacy"
        ];